export default __webpack_public_path__ + "static/media/background_text.a6573baa.webp";